import {
  IDealerApiResonse,
  IDealerFinancialSummary,
  IDealerMin,
  IDealerOrderApiRequest,
  IDealerShipmentsRequest,
  IPreseasonApiRequest,
  IPreseasonApiResponse,
  IPreseasonGoalUpdateRequest,
  IPreseasonTargetUpdateRequest,
  IPreseasonTargetUpdateResponse
} from '.';
import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IApiExecuteRespone, IPagedResponse } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { executeApiRequest } from '../asyncUtils';
import { IShipmentListItem } from '../logistics';
import { IOrderMin } from '../order';
import { IPowerAssessment } from './dealerInterfaces';

export async function fetchDealer(accountNum: string): Promise<IDealerApiResonse> {
  try {
    const response = await httpService.get(ApiUrls.getDealer(accountNum));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchOrders(
  request: IDealerOrderApiRequest
): Promise<IApiExecuteRespone<IPagedResponse<IOrderMin>>> {
  return executeApiRequest(() => httpService.get(ApiUrls.getDealerOrders(request)));
}

export async function fetchDealers(salesDistricts: string[], searchTerm: string = ''): Promise<IDealerMin[]> {
  try {
    const response = await httpService.get(ApiUrls.getDealers(salesDistricts, searchTerm));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchShipments(request: IDealerShipmentsRequest): Promise<IPagedResponse<IShipmentListItem>> {
  try {
    const response = await httpService.get(ApiUrls.getDealerShipments(request));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchFinancials(accountNum: string): Promise<IDealerFinancialSummary[]> {
  try {
    const response = await httpService.get(ApiUrls.getDealerFinancials(accountNum));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchOpenOrders(
  accountNum: string
): Promise<IApiExecuteRespone<{ accountNum: string; amount: number }>> {
  return executeApiRequest(() => httpService.get(`${ApiUrls.getDealer(accountNum)}/OpenOrders`));
}

export async function fetchPowerAssessments(accountNum: string): Promise<IPowerAssessment[]> {
  try {
    const response = await httpService.get(ApiUrls.dealerPowerAssessments(accountNum));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchPreseason(request: IPreseasonApiRequest): Promise<IPreseasonApiResponse> {
  try {
    const response = await httpService.get(ApiUrls.getDealerPreseason(request));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateProgram(request: IPreseasonTargetUpdateRequest): Promise<IPreseasonTargetUpdateResponse> {
  try {
    const response = await httpService.post(ApiUrls.updateDealerPreseasonTarget(request), request);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updatePreseasonGoal(request: IPreseasonGoalUpdateRequest): Promise<IPreseasonApiResponse> {
  try {
    const response = await httpService.post(ApiUrls.updateDealerPreseasonGoal(request), request);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function addPowerAssessment(pa: IPowerAssessment): Promise<IEntityWithMessages<IPowerAssessment>> {
  try {
    const response = await httpService.post(ApiUrls.dealerPowerAssessments(pa.accountNum), pa);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
